<template>
  <div v-if="selectedEvent != null">
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Etkinlik Formları">
          <b-form>
            <b-row>
              <b-col cols="12">
                <b-row>
                  <b-col md="12">
                    <b-form-group label="GSY Formları" label-for="events">
                      <v-select
                        id="events"
                        v-model="selectedEvent"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        label="title"
                        :options="events"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Gsys Formları">
          <b-form>
            <b-row>
              <b-col cols="12">
                <table class="table b-table">
                  <thead>
                    <th>#</th>
                    <th>İçerik</th>
                    <th>Ad Soyad</th>
                    <th>E-Posta</th>
                    <th>Telefon</th>
                    <th>Doğum Tarihi</th>
                    <th>Meslek</th>
                    <th>Öğrenim Durumu</th>
                    <th>Tarih</th>
                  </thead>
                  <tr v-for="form in forms" :key="form.id">
                    <td>{{ form.id }}</td>
                    <td>{{ form.event }}</td>
                    <td>{{ form.name }} {{ form.surname }}</td>
                    <td>{{ form.email }}</td>
                    <td>{{ form.phone }}</td>
                    <td>{{ form.birthday }}</td>
                    <td>{{ form.job }}</td>
                    <td>{{ form.educationStatus }}</td>
                    <td>{{ form.createdAt }}</td>
                  </tr>
                  <thead>
                    <th>#</th>
                    <th>İçerik</th>
                    <th>Ad Soyad</th>
                    <th>E-Posta</th>
                    <th>Telefon</th>
                    <th>Doğum Tarihi</th>
                    <th>Meslek</th>
                    <th>Öğrenim Durumu</th>
                    <th>Tarih</th>
                  </thead>
                </table>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" class="mb-2 mt-2">
                <div class="d-flex justify-content-center align-items-center">
                  <b-pagination
                    :value="1"
                    :total-rows="rows"
                    :per-page="12"
                    first-number
                    last-number
                    align="right"
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mt-1 mb-0"
                    @input="(value) => getFormGsys(value)"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </div>
                <div class="d-flex justify-content-center align-items-center">
                  <b-button
                    class="float-right mt-2 mr-1"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-success"
                    target="_blank"
                    :href="`${baseUrl}/api/v1/export/forms/gsys?eventId=${selectedEvent.id}&lang=${locale}`"
                  >
                    Dışa Aktar
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Ripple from "vue-ripple-directive";
import {
  BRow,
  BCol,
  BImg,
  BCard,
  BForm,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BCardText,
  BFormGroup,
  BPagination,
  BButtonGroup,
  BListGroupItem,
  BButtonToolbar,
} from "bootstrap-vue";

import settings from "../../../settings";
import { Endpoints } from "@core/endpoints/endpoints";
import vSelect from "vue-select";
const endpoints = new Endpoints();
export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,
    BForm,
    BBadge,
    BAlert,
    BButton,
    BAvatar,
    BCardText,
    BFormGroup,
    BPagination,
    BButtonGroup,
    BListGroupItem,
    BButtonToolbar,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      forms: [],
      events: [],
      selectedEvent: null,
      rows: 100,
      currentPage: 1,
      analysisResults: [],
      baseUrl: settings.apiBaseUrl,
      locale: this.$i18n.locale,
    };
  },
  watch: {
    selectedEvent: {
      handler: function (newVal, oldVal) {
        this.getFormGsys(1);
      },
      deep: true,
    },
    currentPage: {
      handler: function (newVal, oldVal) {
        this.getFormGsys(newVal);
      },
      deep: true,
    },
  },
  methods: {
    getFormGsysEvents() {
      endpoints
        .getFormGsysEvents(null, this.$i18n.locale, () => {})
        .then((data) => {
          this.events = [...data.response];
          this.selectedEvent = this.events[0];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getFormGsys(page) {
      endpoints
        .getFormGsys(page, this.selectedEvent.id, this.$i18n.locale, () => {})
        .then((data) => {
          this.forms = [...data.response.data];
          this.rows = data.response.meta.total;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.getFormGsysEvents();
  },
};
</script>
